import React from 'react';
import { createPortal } from 'react-dom';
import { useModal } from '../../components';
import { TooltipContent } from './TooltipContent';
export function Tooltip({ document, modalId, isOpen, parentRef }) {
    const modal = useModal(modalId, isOpen);
    if (!modal) {
        return null;
    }
    return createPortal(React.createElement(TooltipContent, { toolTipText: document, trigger: parentRef }), modal);
}
//# sourceMappingURL=Tooltip.js.map